import requestAction from '../../utils/requestAction'

export const fetchComplaintInternalMessage = (complaintInternalMessageId: string) =>
  requestAction('COMPLAINT_INTERNAL_MESSAGE_DETAIL')(`complaints/internal/message/${complaintInternalMessageId}`, 'GET')
